import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class FollowRotationAttribute extends AbstractBlock {
  constructor() {
    super('follow_rotation_attribute', t.to('向きを同期する', 'follow_rotation'));
  }
  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);

    const target = new Blockly.FieldTextInput('[camera]');
    block
      .appendDummyInput()
      .appendField(target, 'target')
      .appendField(t.to('と向きを同期する', 'follow_rotation'));
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const target = CodeSetting.getFieldValue(block, 'target');
    const str = CodeSetting.buildAttribute([['follow-rotation', `target:${target}`]], attribute);
    return [str];
  }
}
